<template>
  <b-form-group
    :label="label"
    :class="`${classFormGroupBind} b-form-group-styled`"
    :invalid-feedback="invalidFeedback"
    :description="!error || !error.$error ? description : ''"
    :state="error && error.$error ? false : null"
  >
    <lg-number
      class="b-form-input-styled"
      :value="value"
      @input="($value) => $emit('input', $value)"
      :state="error && error.$error ? false : null"
      :precision="precision"
      :disabled="disabled"
      :isMoney="isMoney"
    />
  </b-form-group>
</template>
<script>
import LgNumber from "@/core/components/Inputs/LgNumber.vue";

export default {
  components: {
    LgNumber,
  },
  inheritAttrs: false,
  props: {
    cols: String,
    sm: String,
    md: String,
    classFormGroup: {
      type: String,
      default: "",
    },
    label: String,
    value: [String, Number],

    invalidFeedback: {
      typeof: String,
      default: null,
    },
    description: {
      typeof: String,
      default: "Digite um valor válido",
    },
    error: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isMoney: { type: Boolean, default: false },
    precision: { min: 2, max: 2 },
  },
  computed: {
    classFormGroupBind() {
      const responsiveCols =
        (this.cols !== undefined ? `col-${this.cols} ` : "") +
          (this.sm !== undefined ? `col-sm-${this.sm} ` : "") +
          (this.md !== undefined ? `col-md-${this.md} ` : "") || "col-12 ";
      return `${responsiveCols} ${this.classFormGroup}`;
    },
  },
};
</script>

<style scoped>
.b-form-group-styled {
  font-size: 12px;
}
.b-form-input-styled {
  max-height: 21px;
  margin-top: -8px;
}
</style>
